import React from 'react';
import PropTypes from 'prop-types';
import { Button, Alert } from 'antd';
import { withRouter } from 'react-router';
import { reduxForm, Field } from 'redux-form';
import renderInputDate from '../../components/form/InputDate';
import { required } from '../form/validation';
import s from './styles.less';

class Booking extends React.Component {
  static propTypes = {
    refresh: PropTypes.func,
    change: PropTypes.func,
    handleSubmit: PropTypes.func,
    item: PropTypes.object,
    history: PropTypes.object,
  };
  state = {
    date: `bookDate${Math.random()
      .toString(32)
      .replace('.', '')}`,
    error: false,
  };

  componentDidMount() {
    this.props.change(this.state.date, this.props.item.bookDate);
  }
  submit = async values => {
    this.setState({ error: false });
    try {
      switch (this.props.item.BookingStatus.garageMessage) {
        case 'Booking Requested':
          await fetch('/provider/booking/approve', {
            method: 'post',
            body: {
              bookingId: this.props.item.id,
              bookDate: values[this.state.date],
            },
          });
          break;
        case 'Booking Confirmed':
          await fetch('/provider/booking/done', {
            method: 'post',
            body: { bookingId: this.props.item.id },
          });
          break;
        default:
          return this.props.history.push(
            `/provider/claim/${this.props.item.id}`,
          );
      }
    } catch (e) {
      this.setState({ error: (e.error || e).toString() });
    }
    this.props.refresh();
  };
  renderButtonMessage = () => {
    switch (this.props.item.BookingStatus.garageMessage) {
      case 'Booking Requested':
        return 'Approve date';
      case 'Booking Confirmed':
        return 'Confirm - work done';
      case 'Work Done':
        return 'Request claim';
      default:
        return this.props.item.BookingStatus.garageMessage;
    }
  };
  render() {
    const { item } = this.props;
    return (
      <div className={s.root}>
        <div className={s.type}>{item.type}</div>
        <div className={s.status}>{item.BookingStatus.garageMessage}</div>
        <form
          className={s.form}
          onSubmit={this.props.handleSubmit(this.submit)}
        >
          <Field
            component={renderInputDate}
            name={this.state.date}
            placeholder="Booking date"
            disabled={item.BookingStatusId > 1}
            validate={required}
          />
          <br />
          <Button style={{ width: '100%' }} htmlType="submit" type="primary">
            {this.renderButtonMessage()}
          </Button>
          {this.state.error && (
            <Alert type="error" message={this.state.error} />
          )}
        </form>
      </div>
    );
  }
}

export default withRouter(
  reduxForm({
    form: 'manage-booking',
  })(Booking),
);
